export default {
    add_call_task: "Қоңырау шалуға тапсырманы қосу",
    add_to_funnel: "Қайталауды қосу",
    add_to_funnel_came_and_repeated: " Қайталауға  'Жеткен және қайта' қосу",
    all_days: "Барлық күндер",
    all_doctors: "Барлық дәрігерлер",
    all_plan_treatment_doctors: "Барлық дәрігерлердің емдеу жоспарлары",
    amo_deal_id: "ID мәмілелер Amo",
    api_key: "API кілті",
    applications_and_appeals: "Өтінімдер мен өтініштер",
    are_you_sure_you_want_to_delete_task: "Тапсырманы жойғыңыз келетініне сенімдісіз бе?",
    ask_for_confirmation_response_from_patient: "Пациенттен растау жауабын сұрату",
    attach_file: "Файлды бекіту",
    authorized: "Авторластырылған",
    auto: "Дағдылы",
    binotel: "Binotel",
    binotel_integration: "Binotel біріктіру",
    binotel_integration_instructions: "Dentist Plus-ты Binotelмен біріктіру үшін: <br>1. Аккаунт құру Binotel<br>2. келесі webhook реттеу өтінішімен Binotel қолдау қызметіне хат жазу <b>API CALL SETTINGS</b> және <b>API CALL COMPLETED</b>:<br><span class='text-primary'>{url}</span><br>3. төмендегі өрісте binotel функциясын пайдаланатын клиника персоналының пайдаланушыларын көрсету:",
    binotel_internal: "Binotel ішкі телефон",
    binotel_key: "Binotel кілт",
    binotel_secret: "Binotel құпия кілт",
    button_title: "Батырма атауы",
    call_from_patient: "Пациенттен қоңырау",
    call_from_phone: "Нөмірден қоңырау",
    call_noun: "Қоңырау",
    callee: "Қоңырау шалып жатқан адам",
    came_and_repeated: "Жеткен және қайта",
    canban_mode: "Ванна режимі",
    cancel_sending: "Жолдаудың күшін жою",
    cancellation_response: "Келуді жою үшін жауап",
    change_status: "Статусты өзгерту",
    client_comment: "Клиенттің түсіндірмесі",
    close_the_integration_for_this_branch: "Осы филиал үшін интеграцияны жабу",
    confirmation_response: "Келуді растау үшін жауап",
    copied: "Көшірілді",
    copy_to_clipboard: "Буферге көшіру",
    create_application_on_call: "Өтінімдер мен өтініштерге автоматты түрде қоңырау шалу карточкасын жасау",
    create_card_automatically: "Карточканы автоматты түрде жасау",
    create_lead: "Өтінішті жасау",
    create_lead_on_incoming_message_if_no_lead: "Күй \"Жазылған\" болғанша белсенді сұрау болмаса, WhatsApp-та кіріс хабарларға сұраныс жасаңыз.",
    create_lead_on_incoming_messages: "Белгісіз нөмірден whatsapp кіріс хабарларына өтінім жасау",
    created_visit_administrator: "Сапарды жасаған әкімші",
    crm: "CRM",
    curator_assigned: "Куратор тағайындалды",
    deadline: "Орындау мерзімі",
    deal: "Мәміле",
    do_not_create_duplicates: "Екінші нұсқасын жасамау",
    do_not_create_duplicates_on_call: "Егер \"Жазылған\" статусына дейін белсенді өтінім болса, қоңыраулардың екінші нұсқасын жасамау",
    do_not_create_duplicates_on_messages: "\"Жазылған\" күйі бар белсенді сұрау бар болса, кіріс хабарлар үшін көшірмелерді жасамаңыз.",
    do_not_create_lead_if_patient_exists: "Деректер қорында пациент бар болса, өтінім жасамау",
    do_not_show_anymore: "Енді көрсетпеу",
    domain: "Домен",
    during_incoming: "Кірген кезде",
    during_outcoming: "Шығу үшін",
    feedback: "Пікір",
    feedbacks: "Пікірлер",
    finish_authorization: "Толық авторизация",
    follow: "Өту",
    for_came_from_lead_funnel: "Қайталаудан шыққандар үшін 'Өтінімдер мен өтініштер'",
    for_came_on_first_visit: "Бірінші келуге жеткендер үшін",
    for_came_to_consultation: "Консультацияға жеткендер үшін",
    for_incoming: "Кіріс үшін",
    for_missed: "Өткізіп алғандар үшін",
    for_outcoming: "Шығыс үшін",
    funnel_came_and_repeated: "Қайталама: Жеткендер және қайта",
    generate_key: "Кілтті жасау",
    get_gift: "Сыйлық алу",
    get_sms: "смс алу",
    has_overdue_tasks: "Мерзімі өткен міндеттері бар",
    has_tasks: "Тапсырмалар бар",
    has_today_task: "Бүгінге тапсырмалар бар",
    has_visit: "Келіңіз",
    if_lead_has_no_responsible_then_assign_to_this_person_on_first_save: "Егер өтінімде жауапты адам болмаса, онда ол адамға бірінші сақталған кезде тағайындау",
    inprogress: "Жұмыста",
    insert_script_one_time_instruction: "Бұл скриптті <head> бөліміне орнатыңыз",
    insert_widget_button_instruction: "Осы батырма кодын ол орналасқан жерге орнатыңыз",
    instruction: "Нұсқаулық",
    integration_key: "Біріктіру кілті",
    internal_phone: "Ішкі телефон",
    last_30_days: "Соңғы 30 күн",
    last_thirty_days: "Соңғы 30 күн",
    lead_channel: "Өтінімдер арнасы",
    leave_comment: "Түсіндірме қалдыру",
    manually_selected_user: "Қолмен таңдалған пайдаланушы",
    mark_as_completed: "Орындалған деп белгілеу",
    mark_as_finished: "Орындалған деп белгілеу",
    mark_as_in_progress: "Жұмыста деп белгілеу",
    message_template: "Хабарлама үлгісі",
    message_templates: "Хабарлама үлгілері",
    messenger: "Шабарман",
    messengers: "Хабаршылар",
    move_to_funnel_came_and_repeated: "Қайталамаға «Жеткендер және қайта» жылжыту",
    my_deals: "Менің мәмілелерім",
    my_tasks: "Менің тапсырмаларым",
    no_rating: "Рейтинг жоқ",
    nobody: "Ешкім",
    one_patient_one_lead: "Бір пациент – бір мәміле",
    open_whatsapp: "whatsapp ашу",
    outgoing_calls_through: "арқылы шығыс қоңырау",
    overdue: "Мерзімі өткен",
    patient_already_has_active_deal: "Пациенттің белсенді мәмілесі бар: {dealId}",
    patient_curator: "Пациент бақылаушысы",
    patient_deposit_sum: "Науқастың салым сомасы",
    patient_has_no_future_visits_continue: "Пациенттің келу күндері табылмады. Әлі жалғастыру керек пе?",
    patient_lost: "Науқас жоғалды",
    patient_not_derived: "Пациент анықталмады",
    patient_not_derived_from_phone: "{phone} нөмірден қоңырау - пациент анықталмады",
    patient_stopped_treatment: "Науқас емдеуді тоқтатты",
    paused: "Кідіртуде",
    pbx: "PBX",
    pbx_integration_instructions: "Dentist Plus пен PBX интеграциясы үшін: <br>1. PBX аккаунтты жасау <br>2. Webhooks бөліміндегі PBX жеке кабинетінде url қосу:<br><span class='text-primary'>{url}</span> және API бөлімінде интеграция кілтін алу.<br>3. төмендегі өрісте pbx функциясын пайдаланатын клиника персоналының пайдаланушыларын көрсету және төменде қалған өрістерді толтыру:",
    phone_max_instructions: "Авторизациялауды бастамас бұрын телефон нөмірінде мобильді қосымша арқылы MAX мессенджерінің тіркелгенін тексеріңіз. РФ және РБ үшін 7 және 375 кодтары бар телефон нөмірлерін ғана пайдалануға болады. Мысалы: 79991234567 немесе 375291234567",
    plan_treatments: "Емдеу жоспары",
    planned: "Жоспарланды",
    publish: "Жариялау",
    published: "Жариялау",
    rating: "Рейтинг",
    recall: "Қайта қоңырау шалу",
    recall_on_lead: "Өтінім бойынша қайта қоңырау шалу '{title}'",
    record_myself: "Жазылу",
    record_on_visit: "Қабылдауға жазылу",
    recorded_on_visit: "Қабылдауға жазылды",
    request_qr: "QR сұрау",
    responsible: "Жауапты",
    responsible_on_call: "Қоңырау кезінде жауапты",
    responsible_on_other_leads_not_created_manually: "Қолмен жасалмаған қалған өтінімдер үшін жауапты",
    responsible_type_in_task: "Тапсырмаға жауапты тұлғаның түрі",
    responsible_user: "Жауапты пайдаланушы",
    resume_mailing: "Хабарламаны жалғастыру",
    sales_funnel: "Сатылым қайталамасы",
    search_by_name: "Атауы бойынша іздеу",
    search_by_phone: "Телефон бойынша іздеу",
    see_later: "Кейінірек қарау",
    select_user: "Пайдаланушыны таңдаңыз",
    send_feedback_link_to_patient: "Науқасты тексеру үшін сілтеме жіберіңіз",
    send_receipt_to_patient: "Науқасқа түбіртек жіберіңіз",
    sent_error: "Жіберу қатесі",
    show_call_card: "Қоңырау картасын көрсету",
    sipuni: "Sipuni",
    sipuni_integration_instructions: " Dentist Plus-ты Sipuni біріктіру үшін: <br>1. Sipuni аккаунты жасау<br>2. Sipuni жеке кабинетінде API бөлімінде интеграция кілтін жасау, «Қызметке қосылу» батырмасын басу, «Нөмірге қоңырау шалу» және «АТС оқиғалары» тармақтарында, сондай-ақ «АТС оқиғалары» тармағында қабылдаушы скрипттің URL-ін көрсету:<br><span class='text-primary'>{url}</span><br>3. төмендегі өрісте sipuni функциясын пайдаланатын клиника персоналының пайдаланушыларын көрсету және төменде қалған өрістерді толтыру:",
    sms_code: "SMS код",
    soon: "Жақында",
    stage: "Кезең",
    stages: "Кезеңдер",
    start_period: "Басталу мерзімі",
    system_number: "Жүйедегі нөмір",
    task: "Тапсырма",
    task_date: "Тапсырма күні",
    task_type: "Тапсырма түрі",
    tasks_and_calls: "Тапсырмалар  мен қоңыраулар",
    tilda_integration_instructions: "Tilda сайтындағы пішіндерден веб-хаттарды алу және dentist-plus жүйесінде лид ашу үшін төмендегілер қажет:<br/>1. Tilda жеке кабинетінде Сайт параметрлері → Пішіндер → Webhook кіріңіз <br/>2. Webhook URL өрісіне <span class = 'text-primary'> енгізу{url}</span><br>3. API METHOD өрісінде 'HEADER' дегенді таңдаңыз, 'Field name' өрісінде 'API-KEY' дегенді толтырыңыз, ал 'Api key' өрісінің өзінде төменде жасай алатын кілтті көшіріп алыңыз.<br/>4. Қосымша параметрлерде 'Cookies жіберу' дегенді белсендіріңіз.<br/>5. Келесі өрістер пішіннен автоматты түрде dentist-plus жүйесінде толтырылады: <b>name, phone, email, comment</b>.",
    treatment_plan_created_2: "Емдеу жоспары құрылды",
    treatment_plan_finished: "Емдеу жоспары аяқталды",
    treatment_plan_signed: "Емдеу жоспарына қол қойылды",
    treatment_refused: "Емдеуден бас тарту",
    treatment_started: "Емдеу басталды",
    turn_on_chat_panel: "Чаттар панелін қосу",
    uis: "UIS",
    uis_integration_instructions: " UIS бар Dentist Plus интеграциясы үшін: <br>1. UIS аккаунт жасау<br>2. UIS жеке кабинетінде қажетті пайдаланушының (мысалы, Әкімші) параметрлерін ашу және API функционалдығына қол жеткізу бөлімінде 'API кілтін пайдалану' параметрін белсендіру<br/>3. «Хабарландыру» мәзірінде жауап күту және сөйлесуді аяқтау үшін 2 хабарлама жасау. Екі жағдайда да HTTP хабарлама әдісін белсендіріп, URL өрісінде сілтемені көрсету:<br><span class='text-primary'>{url}</span><br>4. төмендегі өрісте uis функциясын пайдаланатын клиника персоналының пайдаланушыларын көрсету және олардың виртуалды нөмірлерін толтыру (қоңырауларды қабылдау және инициализациялау үшін:",
    undergoing_treatment: "Емделіп жатыр",
    unpublish: "Басылымнан алу",
    use_common_name_for_documents_for_all_branches: "Барлық филиалдар үшін ортақ атауды пайдалану",
    user_add_id: "Автор",
    view: "Қарау",
    visit_confirm: "Қабылдауды растау",
    visit_doctor: "Дәрігерге бару",
    visit_source: "келу көзі",
    without_tasks: "Тапсырмасыз",
    write_in_messenger: "Мессенджерге жазу",
    you_also_can_use_link: "Нысанға сілтемені тікелей пайдалана аласыз"
}
